import React from "react";

export function PageLoader() {

    return <div id="new_loader">
            <div className="before_page_load" style = {{height : '100vh'}}>
                <div className="loader_pulse"><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
}